import { render, staticRenderFns } from "./ConsultaEmailsEnviados.vue?vue&type=template&id=2bb5d9e2&"
import script from "./ConsultaEmailsEnviados.vue?vue&type=script&lang=js&"
export * from "./ConsultaEmailsEnviados.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports